import { React, useEffect, useState } from 'react';
import apiService from '../../services/apiServices';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import Paper from '@mui/material/Paper';
import TopActions from '../actions/TopActions';
import Fab from '@mui/material/Fab';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Modal from '../actions/Modal';
import Toast from '../actions/Toasts';
import { Link } from 'react-router-dom';
import Moment from 'react-moment';
import { Bars } from 'react-loader-spinner'
import ButtonGroup from '@mui/material/ButtonGroup';
import Button from '@mui/material/Button';

export default function BranchList() {
  const [branch, setBranch] = useState([]);
  const [modal, setModal] = useState({});
  const [rowId, setRowId] = useState({});
  const alert = { open: false, message: '', variant: '' };
  const [toast, setToast] = useState(alert);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [loader, setLoader] = useState(true);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  useEffect(() => {
    apiService()
      .get('branch')
      .then((response) => {
        if (response.success) {
          setBranch(response.data);
          //console.log(response.data);
          setLoader(false)
        } else {
          //alert('Error:' + response.errorMessage);
        }
      });
  }, []);

  const handleDelete = (id) => {
    apiService()
      .delete('branch', id)
      .then((response) => {
        if (response) {
          setModal({ open: false });
          setToast({
            open: true,
            message: 'U fshi me sukses!',
            variant: 'success',
          });
          setBranch(branch.filter((branch) => branch.id !== id));
        } else {
          setModal({ open: false });
          setToast({
            open: true,
            message: 'Ka ndodhur nje gabim!',
            variant: 'error',
          });
        }
      });
  };

  const openModal = (id) => {
    setModal({
      open: true,
      tittle: 'Delete',
      message: 'Do you want to delete this row?',
    });
    setToast({ open: false });
    setRowId(id);
  };

  //console.log(workers);
  return (
    <div>
      {loader && <div className="loader-class"><Bars
        height="70"
        width="100%"
        color="#1976d2"
        ariaLabel="bars-loading"
        wrapperStyle={{}}
        wrapperClass=""
        visible={true}
      /></div>}
      {!loader && <>
        <Modal {...modal} handleDelete={() => handleDelete(rowId)} />
        <Toast {...toast} />
        <TopActions newHref="/branchlist/addbranch" saveHref="/dashboard/" />
        <TableContainer component={Paper}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                <TableCell>Nr</TableCell>
                <TableCell>Emri</TableCell>
                <TableCell style={{ width: '150px' }}></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {branch
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((w, index) => (
                  <TableRow key={w.id}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{w.name}</TableCell>

                    <TableCell>
                      <ButtonGroup size="small">
                        <Link to={`branchlist/editbranch/${w.id}`}>
                          <Button>
                            <EditIcon />
                          </Button>
                        </Link>
                        <Button
                          sx={{ ml: 1 }}
                          size="small"
                          onClick={() => openModal(w.id)}
                        >
                          <DeleteIcon />
                        </Button>
                      </ButtonGroup>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={branch.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </>}
    </div>
  );
}
